import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Puzzle = forwardRef<SVGSVGElement, Partial<IconProps>>(function Puzzle({
  styles,
  ...props
}, ref) {
  return <Icon title="Puzzle Icon" description="A miscelaneous puzzle piece" ref={ref} {...stylex.props(styles)} viewBox="0 0 36 36" {...props}>
        <path {...stylex.props(iconsStyles.darkElement)} d="M23.3 6.8c0 .8-.3 1.6-.6 2.3l6.3.6c1.2.2 2 1.2 2.2 2.5l.2 2.6c0 .9-1 1.4-1.9 1.2a4.9 4.9 0 1 0 0 9.3c.9-.3 2 .3 2 1.1l-.3 3.4c-.1 1.3-1 2.3-2.2 2.5a75 75 0 0 1-11 .7 75 75 0 0 1-11-.7 2.7 2.7 0 0 1-2.2-2.5 99.6 99.6 0 0 1 0-17.6C4.9 11 5.8 10 7 9.7c1-.2 4.1-.4 6.3-.6-.3-.7-.6-1.5-.6-2.3a5.2 5.2 0 1 1 10.6 0Z" />
      </Icon>;
});